import { SOActionEnum } from '../../hooks/useRightPanel';

import styles from './action-confirmation.module.scss';

export const ActionConfirmationModalBody = ({ action }: { action: SOActionEnum }) => {
  return (
    <div className={styles.content}>
      You are about to {action} the selected scheduled sales orders. <br />
      Please confirm you wish to continue.
    </div>
  );
};
